<template>
  <div>
    <h2 class="mt-5">
      Which interview format do you want to send a self-schedule invite for?
    </h2>
    <div
      v-if="showValidationErrors && !selectedInterviewFormat"
      class="text-error mt-5"
    >
      This field is required
    </div>
    <div v-if="isFetchingInterviewFormats">
      <v-skeleton-loader
        v-for="i in 5"
        :key="i"
        type="date-picker"
        class="my-2"
      />
    </div>
    <div v-else>
      <InterviewFormatCard
        v-for="(interviewFormat, index) in interviewFormats"
        :isSelected="isSelected(interviewFormat)"
        :key="index"
        :interviewFormat="interviewFormat"
        class="my-5"
        @onSelect="selectInterviewFormat"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import { FETCH_BOOKING_INTERVIEW_FORMATS } from "@/store/modules/bookings/interviews/actions";
import InterviewFormatCard from "@/views/bookings/BookingInterviews/components/InterviewFormatCard";
import { copyState } from "@/utils/helpers";

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

export default {
  components: {
    InterviewFormatCard
  },
  created() {
    this.fetchInterviewFormats({
      bookingId: this.currentBookingId,
      withInclude: true
    });
  },
  data() {
    return {
      selectedInterviewFormat: null,
      showValidationErrors: false
    };
  },
  computed: {
    ...mapInterviewState(
      copyState(["interviewFormats", "isFetchingInterviewFormats"])
    ),
    currentBookingId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapInterviewActions({
      fetchInterviewFormats: FETCH_BOOKING_INTERVIEW_FORMATS
    }),
    selectInterviewFormat(interviewFormat) {
      this.selectedInterviewFormat = interviewFormat;
      this.emitChange();
    },
    emitChange() {
      this.$emit("onChange", { interviewFormat: this.selectedInterviewFormat });
    },
    validateForm() {
      this.showValidationErrors = true;
      return Boolean(this.selectedInterviewFormat);
    },
    isSelected(interviewFormat) {
      return (
        this.selectedInterviewFormat &&
        interviewFormat.id === this.selectedInterviewFormat.id
      );
    }
  }
};
</script>

<style lang="scss"></style>
